












import { Size } from '@front-app/components/constants';
import { TextAlignment } from '@front-app/components/inputs/alignmentButtons';
import { defineComponent, PropType } from '@vue/composition-api';
import { HighlightsHeadingMetadata } from '../../model';

const ALIGNMENT_CLASS: Record<TextAlignment, string> = {
	[TextAlignment.LEFT]: 'align-left',
	[TextAlignment.CENTER]: 'align-center',
	[TextAlignment.RIGHT]: 'align-right',
};

const SIZE_CLASS: Record<Extract<Size, Size.LARGE | Size.MEDIUM>, string> = {
	[Size.LARGE]: 'header-large',
	[Size.MEDIUM]: 'header-medium',
};

export default defineComponent({
	props: {
		meta: {
			type: Object as PropType<HighlightsHeadingMetadata>,
			required: true,
		},
	},
	setup() {
		return {
			SIZE_CLASS,
			ALIGNMENT_CLASS,
		};
	},
});
